import { render, staticRenderFns } from "./ExplainBlock.vue?vue&type=template&id=b1116302&scoped=true"
import script from "./ExplainBlock.vue?vue&type=script&lang=js"
export * from "./ExplainBlock.vue?vue&type=script&lang=js"
import style0 from "./ExplainBlock.vue?vue&type=style&index=0&id=b1116302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1116302",
  null
  
)

export default component.exports